import * as _ from 'underscore';
import * as $ from 'jquery';
import jsPDF from 'jspdf';
import { config } from '../../../pdc-platform/src/ts/config';
import autotable from 'jspdf-autotable';
import * as Utilities from '../../../_common/platform/ts/Utilities';
require('dxAll');
declare var DevExpress: any;
declare var Color: any;
//import { applyPlugin } from 'jspdf-autotable'

import {
    IHTMLTablePropertiesForPrinting,
    IHTMLTablePropertiesForPrintingOptions
} from '../../../pdc-platform/src/ts/Interfaces';
export enum IActionType {
    print = 0,
    exportToPdf,
    copyToClipboard
}

export const addFonts = (doc, actionType) => {
    const fontList = [
        'dxicons',
        'fontawesome-webfont',
        'glyphicons-halflings-regular',
        'ArialNova',
        'ArialNova-Bold',
        'ArialNova-BoldItalic',
        'ArialNova-Italic'
    ];
    if (actionType == IActionType.exportToPdf) {
        for (let index = 0; index < fontList.length; index++) {
            const font = fontList[index];
            const root = config.ASSETS_PATH_ROOT; // + _.last(config.ASSETS_PATH_ROOT) === '/' ? '' : '/';
            doc.addFont(root + 'assets/fonts/' + font + '.ttf', font, 'normal');
            //doc.setFont(font, 'normal')
        }
    }
};

export const isRelativeURL = (url) => {
    try {
        new URL(url);
        return false;
    } catch (e) {
        return true;
    }
};

export const prepareTransparency = (canvas, ctx) => {
    const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imgData.data;

    for (let i = 0; i < data.length; i += 4) {
        if (data[i + 3] === 0) {
            data[i] = 255;
            data[i + 1] = 255;
            data[i + 2] = 255;
            data[i + 3] = 255;
        }
    }
    ctx.putImageData(imgData, 0, 0);
};

export const img2Canvas = (tmpImg, image, index): JQuery.Promise<any> => {
    const def = $.Deferred();
    const canvas = document.createElement('canvas');
    const tempImg = new Image();

    tempImg.crossOrigin = 'anonymous';

    const origImg = $(tmpImg);
    const width = origImg.width();
    const height = origImg.height();

    canvas.width = width;
    canvas.height = height;
    tempImg.src = tmpImg.src;
    tempImg.id = index;
    tempImg.onload = (e) => {
        var self: any = e.target;
        const context = canvas.getContext('2d');

        context.drawImage(self, 0, 0, width, height);

        const imgData = canvas.toDataURL('image/png');

        tmpImg.src = imgData;
        image.replaceWith(tmpImg);
        def.resolve(index);
    };
    tempImg.onerror = (e) => {
        def.resolve(index);
        return;
    };
    return def;
};

export const svg2Canvas = (el, index): JQuery.Promise<any> => {
    var def = $.Deferred();
    let canvas = document.createElement('canvas');
    let img = document.createElement('img');
    if (el == null) {
        def.resolve(index);
        return;
    }
    var svg = $(el);
    var content = svg.wrap('<p></p>').parent().html();
    content = content?.replace(/xlink:title="hide\/show"/g, '');
    content = encodeURIComponent(content);
    //svg.unwrap();
    var image = new Image();
    image.crossOrigin = 'anonymous';
    image.src = 'data:image/svg+xml,' + content;
    var origImg = $(el);
    var width = origImg.width();
    var height = origImg.height();
    image.onload = () => {
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext('2d');
        prepareTransparency(canvas, context);
        context.drawImage(image, 0, 0, width, height);
        var imgData = canvas.toDataURL('image/jpeg', 1.0);
        img.src = imgData;
        svg.replaceWith(img);
        def.resolve(index);
    };

    image.onerror = (e) => {
        def.resolve(index);
    };
    return def;
};

export const mergeStyleCollections = (collections) => {
    return _.reduce(
        collections,
        function (result, collection) {
            var normalizeCollection = {};
            if (collection) {
                for (let index = 0; index < collection.length; index++) {
                    normalizeCollection[collection[index]] = collection[collection[index]];
                }
            }
            return _.extend(result, normalizeCollection);
        },
        {}
    );
};

export const getCellStyle = (data) => {
    const raw: any = data.cell.raw;
    let classrowstyle;
    if (raw.className && raw.className.length > 0) {
        let classes = _.map(raw.className.split(' '), (className) => {
            return '.' + className;
        }).join(', ');
        if (document.querySelector(classes)) {
            classrowstyle = window.getComputedStyle(document.querySelector(classes)); //.getPropertyValue('background-color')
        }
    }
    var dom = new DOMParser()?.parseFromString(raw.innerHTML, 'text/html');
    var trstyle = dom?.querySelector('tr')?.style;
    var rowstyle = raw.style;
    var tdstyle = dom?.querySelector('td')?.style;
    var divstyle = dom?.querySelector('div')?.style;
    var pstyle = dom?.querySelector('p')?.style;
    var spanstyle = dom?.querySelector('span')?.style;
    var style = mergeStyleCollections([trstyle /*, classrowstyle*/, rowstyle, tdstyle, divstyle, pstyle, spanstyle]);
    return style;
};

export const getAlignStyle = (el) => {
    var footerTmp = document.createElement('div');
    footerTmp.innerHTML = el;
    let dom = new DOMParser()?.parseFromString(footerTmp.innerHTML, 'text/html');
    let selector = dom?.querySelector('p') || dom?.querySelector('div') || dom?.querySelector('span');
    let imgstyle = dom?.querySelector('img')?.style;
    let selectorstyle = selector?.style;
    return mergeStyleCollections([selectorstyle, imgstyle]);
};

/**
 * Преобразует цвет (с альфа-каналом) в RGB без прозрачности, сохраняя визуальную светлость.
 * @param {string} color - Цвет в формате rgb(), rgba(), #RRGGBB, #RRGGBBAA.
 * @param {string} [bgColor="#FFFFFF"] - Фон (по умолчанию белый).
 * @returns {[number, number, number]} - [R, G, B] (0-255).
 */
export const colorToArray = (color, bgColor = '#FFFFFF') => {
    // Парсим исходный цвет и фон в [R, G, B, A]
    const [r1, g1, b1, a] = parseColorToRgba(color);
    const [r2, g2, b2] = parseColorToRgba(bgColor);

    // Смешивание с фоном
    const r = Math.round(r1 * a + r2 * (1 - a));
    const g = Math.round(g1 * a + g2 * (1 - a));
    const b = Math.round(b1 * a + b2 * (1 - a));

    return [r, g, b];
};

/**
 * Преобразует цвет (с альфа-каналом) в HEX без прозрачности, сохраняя визуальную светлость.
 * @param {string} color - Цвет в формате rgb(), rgba(), #RRGGBB, #RRGGBBAA.
 * @param {string} [bgColor="#FFFFFF"] - Фон (по умолчанию белый).
 * @returns {string} - HEX-цвет (#RRGGBB).
 */
export const colorToHex = (color, bgColor = '#FFFFFF') => {
    // Парсим исходный цвет и фон в [R, G, B, A]
    const [r1, g1, b1, a] = parseColorToRgba(color);
    const [r2, g2, b2] = parseColorToRgba(bgColor);

    // Смешивание с фоном
    const r = Math.round(r1 * a + r2 * (1 - a));
    const g = Math.round(g1 * a + g2 * (1 - a));
    const b = Math.round(b1 * a + b2 * (1 - a));

    // Преобразование в HEX
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

/**
 * Парсит цвет в [R, G, B, A] (вспомогательная функция).
 */
function parseColorToRgba(color) {
    let r = 0,
        g = 0,
        b = 0,
        a = 1;

    // Обработка rgb/rgba
    if (color.startsWith('rgb')) {
        const values = color.match(/[\d.]+/g).map(Number);
        [r, g, b] = values;
        if (color.startsWith('rgba') && values.length === 4) a = values[3];
    }
    // Обработка HEX (#RRGGBB или #RRGGBBAA)
    else if (color.startsWith('#')) {
        const hex = color.slice(1);
        if (hex.length === 3 || hex.length === 4) {
            r = parseInt(hex[0] + hex[0], 16);
            g = parseInt(hex[1] + hex[1], 16);
            b = parseInt(hex[2] + hex[2], 16);
            if (hex.length === 4) a = parseInt(hex[3] + hex[3], 16) / 255;
        } else if (hex.length === 6 || hex.length === 8) {
            r = parseInt(hex.substring(0, 2), 16);
            g = parseInt(hex.substring(2, 4), 16);
            b = parseInt(hex.substring(4, 6), 16);
            if (hex.length === 8) a = parseInt(hex.substring(6, 8), 16) / 255;
        }
    }

    return [r, g, b, a];
}

/**
 * Преобразует число (0-255) в 2-символьный HEX.
 */
function toHex(value) {
    return value.toString(16).padStart(2, '0').toUpperCase();
}

isDataURL.regex =
    /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;

function isDataURL(s) {
    return !!s.match(isDataURL.regex);
}
export const isImgExist = (doc, img) => {
    try {
        doc.getImageProperties(img);
        return true;
    } catch (e) {
        console.error(e.message);
        return false;
    }
};

export const addExtraInfo = (
    name,
    pdfOptions,
    coverPageImg,
    doc,
    headerImg,
    headerTextAligh,
    right,
    left,
    titleInlineSize,
    inlineSizeClock,
    inlineSize,
    footerImg,
    footerTextAligh,
    MARGIN
) => {
    const defs = [];
    let scale = 0.3;
    let pageWidth = doc.internal.pageSize.getWidth(); // - left - right;
    let pageCount = doc.internal.getNumberOfPages();
    let isCoverPage = coverPageImg?.src && isImgExist(doc, coverPageImg);
    doc.setFont('helvetica', 'italic');
    doc.setFontSize(8);

    for (let i = 1; i <= pageCount; i++) {
        const def = $.Deferred();

        defs.push(def);
        doc.setPage(i);
        let pages =
            'Page ' + String(isCoverPage ? i + 1 : i) + ' of ' + String(isCoverPage ? pageCount + 1 : pageCount);
        if (pdfOptions?.showPages) {
            doc.text(pages, pageWidth / 2, doc.internal.pageSize.height - 10, {
                align: 'center'
            });
        }

        if (headerImg?.src && isImgExist(doc, headerImg)) {
            const HeaderImageData = doc.getImageProperties(headerImg);

            let elementWidth = HeaderImageData.width;
            let scale = 0.3;

            if (elementWidth * scale > pageWidth) {
                scale = pageWidth / elementWidth;
            }
            let headerX;
            switch (headerTextAligh) {
                case 'center':
                    headerX = pageWidth / 2 - (elementWidth * scale) / 2;
                    break;
                case 'right':
                    headerX = pageWidth - elementWidth * scale - right;
                    break;
                default:
                    headerX = left;
            }
            doc.addImage(
                headerImg,
                //'PNG',
                headerX,
                (pdfOptions?.showTitle ? titleInlineSize : 0) +
                    (pdfOptions?.showClock ? inlineSizeClock : 0) +
                    inlineSize,
                elementWidth * scale,
                HeaderImageData.height * scale,
                'header' + i.toString()
                // 'FAST'
            );
        }

        if (pdfOptions?.showTitle) {
            doc.text(name, doc.internal.pageSize.width / 2, titleInlineSize, {
                align: 'center'
            });
        }
        if (pdfOptions?.showClock) {
            const now = new Date();
            const textWidth = doc.getTextWidth(now.toDateString());

            doc.text(now.toDateString(), pageWidth - textWidth - right, inlineSize + titleInlineSize);
        }

        if (footerImg?.src && isImgExist(doc, footerImg)) {
            const FooterImageData = doc.getImageProperties(footerImg);
            let elementWidth = FooterImageData.width;
            let scale = 0.3;
            if (elementWidth * scale > pageWidth) {
                scale = pageWidth / elementWidth;
            }
            let footerleft;
            switch (footerTextAligh) {
                case 'center':
                    footerleft = (pageWidth - elementWidth * scale) / 2;
                    break;
                case 'right':
                    footerleft = pageWidth - elementWidth * scale - right;
                    break;
                default:
                    footerleft = left;
            }

            doc.addImage(
                footerImg,
                // 'PNG',
                footerleft,
                doc.internal.pageSize.height - FooterImageData.height * scale - MARGIN, //y
                elementWidth * scale,
                FooterImageData.height * scale,
                'footer' + i.toString()
                //'FAST'
            );
        }
    }
    return defs;
};

var COLORS = {
    ALICEBLUE: '#f0f8ffff',
    ANTIQUEWHITE: '#faebd7ff',
    AQUA: '#00ffffff',
    AQUAMARINE: '#7fffd4ff',
    AZURE: '#f0ffffff',
    BEIGE: '#f5f5dcff',
    BISQUE: '#ffe4c4ff',
    BLACK: '#000000ff',
    BLANCHEDALMOND: '#ffebcdff',
    BLUE: '#0000ffff',
    BLUEVIOLET: '#8a2be2ff',
    BROWN: '#a52a2aff',
    BURLYWOOD: '#deb887ff',
    CADETBLUE: '#5f9ea0ff',
    CHARTREUSE: '#7fff00ff',
    CHOCOLATE: '#d2691eff',
    CORAL: '#ff7f50ff',
    CORNFLOWERBLUE: '#6495edff',
    CORNSILK: '#fff8dcff',
    CRIMSON: '#dc143cff',
    CYAN: '#00ffffff',
    DARKBLUE: '#00008bff',
    DARKCYAN: '#008b8bff',
    DARKGOLDENROD: '#b886bbff',
    DARKGRAY: '#a9a9a9ff',
    DARKGREEN: '#006400ff',
    DARKGREY: '#a9a9a9ff',
    DARKKHAKI: '#bdb76bff',
    DARKMAGENTA: '#8b008bff',
    DARKOLIVEGREEN: '#556b2fff',
    DARKORANGE: '#ff8c00ff',
    DARKORCHID: '#9932ccff',
    DARKRED: '#8b0000ff',
    DARKSALMON: '#e9967aff',
    DARKSEAGREEN: '#8fbc8fff',
    DARKSLATEBLUE: '#483d8bff',
    DARKSLATEGRAY: '#2f4f4fff',
    DARKSLATEGREY: '#2f4f4fff',
    DARKTURQUOISE: '#00ced1ff',
    DARKVIOLET: '#9400d3ff',
    DEEPPINK: '#ff1493ff',
    DEEPSKYBLUE: '#00bfffff',
    DIMGRAY: '#696969ff',
    DIMGREY: '#696969ff',
    DODGERBLUE: '#1e90ffff',
    FIREBRICK: '#b22222ff',
    FLORALWHITE: '#fffaf0ff',
    FORESTGREEN: '#228b22ff',
    FUCHSIA: '#ff00ffff',
    GAINSBORO: '#dcdcdcff',
    GHOSTWHITE: '#f8f8ffff',
    GOLD: '#ffd700ff',
    GOLDENROD: '#daa520ff',
    GRAY: '#808080ff',
    GREEN: '#008000ff',
    GREENYELLOW: '#adff2fff',
    GREY: '#808080ff',
    HONEYDEW: '#f0fff0ff',
    HOTPINK: '#ff69b4ff',
    INDIANRED: '#cd5c5cff',
    INDIGO: '#4b0082ff',
    IVORY: '#fffff0ff',
    KHAKI: '#f0e68cff',
    LAVENDER: '#e6e6faff',
    LAVENDERBLUSH: '#fff0f5ff',
    LAWNGREEN: '#7cfc00ff',
    LEMONCHIFFON: '#fffacdff',
    LIGHTBLUE: '#add8e6ff',
    LIGHTCORAL: '#f08080ff',
    LIGHTCYAN: '#e0ffffff',
    LIGHTGOLDENRODYELLOW: '#fafad2ff',
    LIGHTGRAY: '#d3d3d3ff',
    LIGHTGREEN: '#90ee90ff',
    LIGHTGREY: '#d3d3d3ff',
    LIGHTPINK: '#ffb6c1ff',
    LIGHTSALMON: '#ffa07aff',
    LIGHTSEAGREEN: '#20b2aaff',
    LIGHTSKYBLUE: '#87cefaff',
    LIGHTSLATEGRAY: '#778899ff',
    LIGHTSLATEGREY: '#778899ff',
    LIGHTSTEELBLUE: '#b0c4deff',
    LIGHTYELLOW: '#ffffe0ff',
    LIME: '#00ff00ff',
    LIMEGREEN: '#32cd32ff',
    LINEN: '#faf0e6ff',
    MAGENTA: '#ff00ffff',
    MAROON: '#800000ff',
    MEDIUMAQUAMARINE: '#66cdaaff',
    MEDIUMBLUE: '#0000cdff',
    MEDIUMORCHID: '#ba55d3ff',
    MEDIUMPURPLE: '#9370dbff',
    MEDIUMSEAGREEN: '#3cb371ff',
    MEDIUMSLATEBLUE: '#7b68eeff',
    MEDIUMSPRINGGREEN: '#00fa9aff',
    MEDIUMTURQUOISE: '#48d1ccff',
    MEDIUMVIOLETRED: '#c71585ff',
    MIDNIGHTBLUE: '#191970ff',
    MINTCREAM: '#f5fffaff',
    MISTYROSE: '#ffe4e1ff',
    MOCCASIN: '#ffe4b5ff',
    NAVAJOWHITE: '#ffdeadff',
    NAVY: '#000080ff',
    OLDLACE: '#fdf5e6ff',
    OLIVE: '#808000ff',
    OLIVEDRAB: '#6b8e23ff',
    ORANGE: '#ffa500ff',
    ORANGERED: '#ff4500ff',
    ORCHID: '#da70d6ff',
    PALEGOLDENROD: '#eee8aaff',
    PALEGREEN: '#98fb98ff',
    PALETURQUOISE: '#afeeeeff',
    PALEVIOLETRED: '#db7093ff',
    PAPAYAWHIP: '#ffefd5ff',
    PEACHPUFF: '#ffdab9ff',
    PERU: '#cd853fff',
    PINK: '#ffc0cbff',
    PLUM: '#dda0ddff',
    POWDERBLUE: '#b0e0e6ff',
    PURPLE: '#800080ff',
    REBECCAPURPLE: '#663399ff',
    RED: '#ff0000ff',
    ROSYBROWN: '#bc8f8fff',
    ROYALBLUE: '#4169e1ff',
    SADDLEBROWN: '#8b4513ff',
    SALMON: '#fa8072ff',
    SANDYBROWN: '#f4a460ff',
    SEAGREEN: '#2e8b57ff',
    SEASHELL: '#fff5eeff',
    SIENNA: '#a0522dff',
    SILVER: '#c0c0c0ff',
    SKYBLUE: '#87ceebff',
    SLATEBLUE: '#6a5acdff',
    SLATEGRAY: '#708090ff',
    SLATEGREY: '#708090ff',
    SNOW: '#fffafaff',
    SPRINGGREEN: '#00ff7fff',
    STEELBLUE: '#4682b4ff',
    TAN: '#d2b48cff',
    TEAL: '#008080ff',
    THISTLE: '#d8bfd8ff',
    TOMATO: '#ff6347ff',
    TRANSPARENT: '#00000000',
    TURQUOISE: '#40e0d0ff',
    VIOLET: '#ee82eeff',
    WHEAT: '#f5deb3ff',
    WHITE: '#ffffffff',
    WHITESMOKE: '#f5f5f5ff',
    YELLOW: '#ffff00ff',
    YELLOWGREEN: '#9acd32ff'
};
export const tableToPDF = (doc, tableProps, width, margin, cellPadding, scale) => {
    //applyPlugin(jsPDF);
    autotable(doc, {
        //startY: startY,
        showHead: 'everyPage',
        html: tableProps.html,
        rowPageBreak: 'avoid',
        includeHiddenHtml: true,
        tableWidth: width,
        styles: { lineWidth: 0.3 },
        columnStyles: tableProps.columnStyles,
        headStyles: tableProps.headerStyles,
        bodyStyles: tableProps.bodyStyles,
        alternateRowStyles: tableProps.alternateRowStyles,
        useCss: true,
        theme: tableProps.themeType === true ? 'striped' : 'grid',
        margin: margin,
        didParseCell: (data) => {
            try {
                data.cell.styles.cellPadding = {
                    top: cellPadding,
                    right: cellPadding,
                    bottom: cellPadding,
                    left: cellPadding
                };
                data.cell.text = _.map(data.cell.text, (text: string) => {
                    return text.replace(/\t/g, ' ').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
                });
                let style = getCellStyle(data);
                if (style) {
                    var color = style['color'];
                    if (color) {
                        let rgb = color
                            .substring(4, color.length - 1)
                            .replace(/ /g, '')
                            .split(',');

                        data.cell.styles.textColor = [parseInt(rgb[0]), parseInt(rgb[1]), parseInt(rgb[2])];
                    }
                    var fontWeight = style['font-weight'];
                    switch (fontWeight) {
                        case 'bold':
                            data.cell.styles.fontStyle = 'bold';
                            break;
                        case 'bolder':
                            data.cell.styles.fontStyle = 'bold';
                            break;
                    }
                    data.cell.styles.fontSize = data.cell.styles.fontSize - 4; //* scale;
                    let fontStyle = style['font-style'];
                    switch (fontStyle) {
                        case 'italic':
                            data.cell.styles.fontStyle = 'italic';
                            break;
                    }

                    switch (data.cell.styles.fontStyle) {
                        case 'bold':
                            if (doc.getFont('ArialNova-Bold')) {
                                data.cell.styles.font = 'ArialNova-Bold';
                            }
                            break;
                        case 'italic':
                            if (doc.getFont('ArialNova-Italic')) {
                                data.cell.styles.font = 'ArialNova-Italic';
                            }
                            break;
                        case 'bolditalic':
                            if (doc.getFont('ArialNova-BoldItalic')) {
                                data.cell.styles.font = 'ArialNova-BoldItalic';
                            }
                            break;
                        default:
                            if (doc.getFont('ArialNova')) {
                                data.cell.styles.font = 'ArialNova';
                            }
                            break;
                    }

                    /*let textoverflow = style['text-overflow'];
                    switch (textoverflow) {
                        case 'ellipsis':
                            data.cell.styles.overflow = 'ellipsize';
                            break;
                    }
                    if (data.cell.section !== 'head') {
                        let overflowwrap = style['overflow-wrap'];
                        switch (overflowwrap) {
                            case 'break-word':
                                data.cell.styles.overflow = 'linebreak';
                                break;
                            default:
                                data.cell.styles.overflow = 'ellipsize';
 
                                // data.cell.styles.overflow = 'visible';
                                break;
                        }
                    }*/
                }
            } catch (e) {
                console.log(e.message);
            }
        },
        willDrawCell: (data) => {
            try {
                let style = getCellStyle(data);
                let rgb;
                let backgroundColor;
                if (data.cell.styles.fillColor != null) {
                    rgb = data.cell.styles.fillColor;
                    if (_.isArray(rgb)) {
                        rgb = [parseInt(rgb[0]), parseInt(rgb[1]), parseInt(rgb[2])];
                    }
                }

                if (style) {
                    backgroundColor = style['background-color'];
                    if (backgroundColor) {
                        try {
                            if (COLORS[backgroundColor.toUpperCase()]) {
                                backgroundColor = COLORS[backgroundColor.toUpperCase()];
                            }
                        } catch (e) {}
                        rgb = colorToArray(backgroundColor);
                    }
                }

                if (rgb) {
                    data.cell.styles.fillColor = 155;
                    if (_.isArray(rgb)) {
                        doc.setFillColor(rgb[0], rgb[1], rgb[2]);
                    } else {
                        doc.setFillColor(rgb);
                    }

                    if (style) {
                        switch (style['text-align']) {
                            case 'center':
                                data.cell.styles.halign = 'center';
                                break;
                            case 'right':
                                data.cell.styles.halign = 'right';
                                break;
                            case 'justify':
                                data.cell.styles.halign = 'justify';
                                break;
                            default:
                                data.cell.styles.halign = 'left';
                        }
                    }
                }
            } catch (e) {
                console.log(e.message);
            }
        },
        didDrawCell: (data) => {
            try {
                const raw: any = data.cell.raw;

                if (raw && typeof raw.getElementsByTagName == 'function') {
                    const img = raw.getElementsByTagName('img');

                    if (img && img.length > 0) {
                        const src = $(img).attr('src');

                        if (src && src.length > 0) {
                            if (isDataURL(src)) {
                                let imgW = img[0].width * scale;
                                let imgH = img[0].height * scale;
                                if (imgH > data.cell.height - cellPadding * 2) {
                                    data.cell.contentHeight = imgH + cellPadding * 2;
                                    data.cell.height = imgH + cellPadding * 2;
                                }
                                doc.addImage(
                                    src,
                                    'PNG',
                                    data.cell.x + data.cell.width / 2 - imgW / 2,
                                    data.cell.y + 1, //  + data.cell.height / 2 - imgH / 2,
                                    imgW,
                                    imgH
                                );
                            }
                        }
                    }
                }
            } catch (e) {
                console.log(e.message);
            }
        }
    });
};
export function makeTable(
    popupDocument,
    options: IHTMLTablePropertiesForPrintingOptions,
    theme?,
    userWordWrapEnabled?,
    cid?
): IHTMLTablePropertiesForPrinting {
    try {
        // var widget = popupDocument.getElementById(cid);
        var grid = popupDocument.getElementsByClassName('dx-datagrid');
        const gridtable = $(grid).find('.dx-datagrid-rowsview').find('.dx-datagrid-table');

        const freespacerow = $(grid).find('.dx-freespace-row ');
        if (freespacerow && freespacerow.length > 0) {
            freespacerow.remove();
        }
        let offset: any = $(grid).offset();
        offset.height = $(grid).height();
        offset.width = $(grid).width();
        const result: IHTMLTablePropertiesForPrinting = {
            html: gridtable[0] as HTMLTableElement,
            headerStyles: {},
            offset: offset
        };
        var overflow = 'ellipsize';

        const rowbgColor = theme && theme[theme.rowbgColor];
        const rowColor = theme && theme[theme.rowColor];
        const rowAlternation = theme && theme[theme.rowAlternation];
        const wordWrapEnabled = theme && theme[theme.wordWrapEnabled];
        const allowWordWrap = theme && theme[theme.allowWordWrap];
        const computedStyle = window.getComputedStyle($(grid).find('.dx-datagrid-headers')[0]);
        const bGColor = computedStyle.getPropertyValue('background-color');
        const headerBGColor = bGColor && colorToArray(bGColor);
        var headerBGColorHex = bGColor && colorToHex(bGColor);

        const color = computedStyle.getPropertyValue('color');
        const headerColor = color && colorToArray(color);
        const headerFontStyle = computedStyle.getPropertyValue('font-style');
        const headerFontWeight = computedStyle.getPropertyValue('font-weight');

        if (headerBGColor != null && headerBGColor.length === 3) {
            result.headerStyles = {
                fillColor: [headerBGColor[0], headerBGColor[1], headerBGColor[2]]
            };
        }

        if (headerColor != null && headerColor.length === 3) {
            result.headerStyles = _.extend({}, result.headerStyles, {
                textColor: [headerColor[0], headerColor[1], headerColor[2]]
            });
        }

        if (allowWordWrap ? userWordWrapEnabled : wordWrapEnabled) {
            overflow = 'linebreak';
        }

        result.headerStyles = _.extend({}, result.headerStyles, {
            overflow: overflow
        });

        if (headerFontStyle != null && headerFontWeight != null) {
            if (headerFontWeight === 'bold' || headerFontWeight === 'bolder' || parseInt(headerFontWeight) >= 700)
                result.headerStyles = _.extend({}, result.headerStyles, { fontStyle: 'bold' });
            else {
                result.headerStyles = _.extend({}, result.headerStyles, {
                    fontStyle: headerFontStyle
                });
            }
        }

        // Получение заголовков таблицы
        const headerRows = $(grid).find('.dx-datagrid-headers').find('tr');

        const td = $(headerRows).find('td');
        _.map(td, (cell) => {
            var _html = cell.innerHTML;
            let style = cell.style;
            style.backgroundColor = headerBGColorHex;
            let pstyle = style.cssText;
            $(cell).replaceWith(
                '<th class="dx-datagrid-headers" style="' +
                    pstyle +
                    '" colSpan=' +
                    cell.colSpan +
                    ' rowSpan=' +
                    cell.rowSpan +
                    ' > ' +
                    _html +
                    '</th>'
            );
        });
        const header = result.html.createTHead();

        $(header).append(headerRows);
        result.html = _.clone(result.html);
        var altArr;
        var rowbgColorArrHex;
        if (rowbgColor) {
            var rowbgColorArr = colorToArray(rowbgColor);
            rowbgColorArrHex = colorToHex(rowbgColor);
            var rowColorArr = colorToArray(rowColor);

            if (rowbgColorArr != null && rowbgColorArr.length === 3) {
                result.bodyStyles = {
                    fillColor: rowbgColorArr
                };
            }

            if (rowAlternation) {
                var isDark = Utilities.isDark(rowbgColorArrHex);
                if (isDark) {
                    var alt = Color(rowbgColorArrHex).lighten(5).hexString();
                    altArr = colorToArray(alt);
                } else {
                    var alt = Color(rowbgColorArrHex).darken(5).hexString();
                    altArr = colorToArray(alt);
                }
                if (altArr != null && altArr.length === 3) {
                    result.alternateRowStyles = {
                        fillColor: rowbgColorArr
                    };
                }
                if (rowbgColorArr != null && rowbgColorArr.length === 3) {
                    result.bodyStyles = {
                        fillColor: altArr
                    };
                }
            }
            if (rowColorArr != null && rowColorArr.length === 3) {
                result.bodyStyles = _.extend({}, result.bodyStyles, {
                    textColor: rowColorArr
                });
            }
        }
        result.columnStyles = getColumnStyle(gridtable, options.scale, overflow);

        /* const transparentRect = popupDocument.createElement('div');
        transparentRect.style.width = offset.width + 'px';
        transparentRect.style.height = offset.height + 'px';
        transparentRect.style.backgroundColor = 'transparent';
        transparentRect.style.border = '0px solid rgba(0,0,0,0.1)'; */ // легкая граница для визуализации
        // transparentRect.style.pageBreakInside='always'
        // Заменяем grid на прямоугольник
        //$(grid).replaceWith('');
        // $(grid).replaceWith(transparentRect);
        //$(grid).css('visibility','hidden');
        //$(grid).addClass('d-print-none')
        // $(grid).parent().css('opacity', 0);
        result.themeType = theme && theme['widget-grid-row-alternation'];

        return result;
    } catch (e) {
        console.log(e.message);
    }
}

function getColumnStyle(gridTable: JQuery<HTMLElement>, scale: number, overflow) {
    try {
        const rows = gridTable.find('tr');

        if (rows.length === 0) return {};

        const maxDimensions = {};
        for (let i = 0; i < rows.length; i++) {
            const cells = rows[i].getElementsByTagName('td');

            for (let j = 0; j < cells.length; j++) {
                const img = cells[j].querySelector('img');
                maxDimensions[j] = {
                    overflow: overflow
                };
                if (img) {
                    const imgWidth = img.clientWidth;
                    const imgHeight = img.clientHeight;

                    if (!maxDimensions[j]) {
                        maxDimensions[j] = {
                            minCellWidth: 0,
                            minCellHeight: 0,
                            overflow: overflow
                        };
                    }

                    if (imgWidth > maxDimensions[j].minCellWidth) {
                        maxDimensions[j].minCellWidth = imgWidth * scale + 2;
                        maxDimensions[j].overflow = overflow;
                    }

                    if (imgHeight > maxDimensions[j].minCellHeight) {
                        maxDimensions[j].minCellHeight = imgHeight * scale + 2;
                        maxDimensions[j].overflow = overflow;
                    }
                }
            }
        }

        return maxDimensions;
    } catch (e) {
        console.log(e.message);
    }
}

